<template>
    <section class="questions-wrap position-relative">
        <div class="container">
            <div class="row">

                <!-- Sidebar -->
                <div class="col-md-2">
                    <questions-sidebar />
                </div>

                <!-- All Questions -->
                <div class="col-md-7">
                    <div class="questions-tab">
                        <div class="questions-tab-wrapper">
                            <questions-filter />

                            <div v-loading="isLoading" class="question-lists">
                                <questions-lists :showTags="true" v-if="!isLoading && fetchResult.items" :lists="fetchResult.items" />
                                <p v-else>No Data Found</p>
                            </div>


                            <question-pagination />
                        </div>
                    </div>
                </div>

                <!-- Right Sidebar -->
                <div class="col-md-3">
                    <questions-sidebar-2 />
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import dlabData from '@/store/store.js'
import QuestionsFilter from '../dynamic/QuestionsFilter.vue';
import QuestionsSidebar from '../sidebars/QuestionsSidebar.vue';
import QuestionsSidebar2 from '../sidebars/QuestionsSidebar2.vue';
import QuestionsLists from '../cards/QuestionsLists.vue';
import QuestionPagination from '../dynamic/QuestionPagination.vue';

export default {
    name: 'Questions',
    components: {
        QuestionsSidebar,
        QuestionsSidebar2,
        QuestionsFilter,
        QuestionsLists,
        QuestionPagination,
    },
    data() {
        return {
            activeName: 'questions',
            dlabData,
            fetchResult: [],
            isLoading: false
        }
    },
    methods: {
        fetchQuestion() {
            this.isLoading = true

            // fetch data from api or you can get data from (store/store.js)
            fetch('https://api.stackexchange.com/2.3/questions?pagesize=40&order=desc&sort=activity&site=stackoverflow')
                .then(response => {
                    return response.json()
                })
                .then((data) => {
                    this.fetchResult = data;
                    this.isLoading = false
                })
                .catch(error => {
                    console.error(error.message)
                })
                .finally(() => {
                    this.isLoading = false
                });
        }
    },
    mounted() {
        this.fetchQuestion();
    }
}
</script>